import { action } from 'typesafe-actions';
import { ECustomerUserPermissionType, IUser } from '../user/types';
import { Types } from './types';

export const loadCustomerUsers = (customerId: string) =>
  action(Types.LOAD_CUSTOMER_USERS, { customerId });
export const loadCustomerUsersSuccess = (customerId: string, users: IUser[]) =>
  action(Types.LOAD_CUSTOMER_USERS_SUCCESS, { customerId, users });
export const loadCustomerUsersFailure = (error: unknown) =>
  action(Types.LOAD_CUSTOMER_USERS_FAILURE, { error });

export const createCustomerUser = (
  customerId: string,
  name: string,
  email: string,
  admin: boolean,
  fabricationPermission: boolean,

  ordersViewPermission: boolean,
  ordersViewPrice: boolean,
  financialViewPermission: boolean,
  orderInputPermission: boolean,

  coreTeam: boolean
) =>
  action(Types.CREATE_CUSTOMER_USER, {
    customerId,
    name,
    email,
    admin,
    fabricationPermission,
    financialViewPermission,
    ordersViewPrice,
    ordersViewPermission,
    orderInputPermission,
    coreTeam
  });
export const createCustomerUserSuccess = () =>
  action(Types.CREATE_CUSTOMER_USER_SUCCESS);
export const createCustomerUserFailure = (error: unknown) =>
  action(Types.CREATE_CUSTOMER_USER_FAILURE, { error });

export const updateCustomerUserPermission = (
  updatedUser: IUser,
  customerId: string,
  updateType: 'add' | 'remove',
  customerUserPermissionType?: ECustomerUserPermissionType
) =>
  action(Types.UPDATE_CUSTOMER_USER_PERMISSION, {
    updatedUser,
    customerId,
    updateType,
    customerUserPermissionType
  });

export const updateCustomerUserPermissionSuccess = (
  updatedUser: IUser,
  customerId: string
) =>
  action(Types.UPDATE_CUSTOMER_USER_PERMISSION_SUCCESS, {
    updatedUser,
    customerId
  });
export const updateCustomerUserPermissionFailure = (
  error: unknown,
  updatedUser: IUser,
  customerId: string
) =>
  action(Types.UPDATE_CUSTOMER_USER_PERMISSION_FAILURE, {
    error,
    customerId,
    updatedUser
  });

export const cleanErrorFromCustomerUser = (
  updatedUser: IUser,
  customerId: string
) => action(Types.CLEAN_ERROR_FROM_CUSTOMER_USER, { updatedUser, customerId });

export const removeCustomerUser = (updatedUser: IUser, customerId: string) =>
  action(Types.REMOVE_CUSTOMER_USER, { updatedUser, customerId });
export const removeCustomerUserSucess = () =>
  action(Types.REMOVE_CUSTOMER_USER_SUCCESS);
export const removeCustomerUserFailure = (error: unknown) =>
  action(Types.REMOVE_CUSTOMER_USER_FAILURE, { error });

export const cleanErrors = () => action(Types.CLEAN_ERRORS);
